const Header = () => {
  return (
    <header className="main-header">
      <nav>
        <a href="#about-me">About</a>
        <a href="https://docs.google.com/document/d/1WBq3zM5R4vk9N4lgnAMcHCdFLws4YcpQUoTjzcG7sXo/edit?usp=sharing" target="_blank">Resume</a>
        <a href="#projects">Projects</a>
        <a href="mailto:tylerzeman1999@gmail.com" target="_blank">Contact</a>
      </nav>
    </header>
  );
};

export default Header;
